export enum OrderStepCode {
  Demographics = 0,
  Tests = 1,
  AOE = 2,
  Diagnosis = 3,
  MedicalNecessity = 4,
  Specimens = 5,
  BeaconLbs = 6,
  DocumentUpload = 7,
  CompleteOrder = 8,
  StandingOrder = 9,
  OrderDone = 10,
  BenefitsInquiryDone = 11,
  OrderInfo = 12
}
